import React, { useEffect, useState } from 'react'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, ButtonCreate } from '../../../components/styles/subheader-style'
import { Content } from './style'
import { GlobalTable, Th, HeaderLine, Tr, Td } from '../../../components/styles/table-style'
import axios from '../../../config/axios'
import { Outlet, useNavigate } from 'react-router-dom'

const ResourcesSubHeader:React.FC = () => {
  const navigate = useNavigate()
  
  const handleCreateClick = () => {
    navigate('create')
  }
  
  return (
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>Insumos</SectionName>
    </LeftSide>
    <RightSide>
      <ButtonCreate onClick={handleCreateClick}>+ Adicionar Insumo</ButtonCreate>
    </RightSide>
  </SubHeaderContainer>
  )
}

const ResourcesContent = () => {  
  return (
    <>
    <ResourcesSubHeader />
    <Content>
      <Outlet />
    </Content>
    </>
  )
}

export default ResourcesContent
